if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      // Only run setDisabled for traditional Shopify products, not Combined Listings
      const isCombinedListing = this.querySelector('input[data-option-value-id]');
      if (!isCombinedListing) {
        this.setDisabled();
      }
      this.setImageSet();
      initJetHotAndAddons();
      syncPopupHeight();
    }

    /*
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }
    */

    onVariantChange(event) {
      const productElement = event.target.closest('#product-pdp');
      if (productElement) {
        const optionValueElement = event.target;
        // console.log("optionValueElement", optionValueElement);
        const sectionId = productElement.dataset.sectionId;
        const optionValueSelectors = event.target.closest('.optionValueSelectors');

        // Combined listings: We use old and new product urls to determine if the product should change
        const oldProductUrl = productElement.dataset.productUrl;
        const newProductUrl = optionValueElement.dataset.productUrl;
        console.log("newProductUrl", newProductUrl);
        // Get the selected option value IDs and format as query param
        const selectedOptionValues = Array.from(
          optionValueSelectors.querySelectorAll('fieldset input:checked')
          ).map(({dataset}) => dataset.optionValueId);
        const params = selectedOptionValues.length > 0
          ? `&option_values=${selectedOptionValues.join(',')}`
          : '';

        // Deferred variants: Fetch the option value picker with the new availability state when remaining on the same product
        // Combined listings: Fetch the product associated with the selected option value and replace the entire product if switching to a sibling product
        fetch(`${newProductUrl}?section_id=${sectionId}${params}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // Combined listings: If the product changed, replace the old product section with the new product section
          if (newProductUrl && oldProductUrl !== newProductUrl) {
            productElement.parentNode.insertBefore(html.querySelector('#product-pdp'), productElement);
            productElement.remove();

            // Focus the input for the last clicked option value
            // document.querySelector(`#${event.target.id}`).focus();

            return;
          }

          //const optionValueSelectors = event.target.closest('.optionValueSelectors');
          optionValueSelectors.innerHTML = html.querySelector('.optionValueSelectors').innerHTML;
          document.querySelector(`#${event.target.id}`).focus();

          // Update any other sections that depend on the option value picker
        });
      }
      
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    // updateOptions() {
    //   this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
    //   this.options = [];
    //   this.fieldsets.forEach((fieldset, i) => {
    //     if (fieldset.querySelector('select')) {
    //       this.options.push(fieldset.querySelector('select').value);
    //     } else if (fieldset.querySelectorAll('input').length) {
    //       this.options.push(fieldset.querySelector('input:checked').value);
    //     }
    //   });
    // }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          const checkedInput = fieldset.querySelector('input:checked');

          if (checkedInput) {
            this.options.push(checkedInput.value);
          } else {
            // fallback → pick first available input
            const firstInput = fieldset.querySelector('input');
            this.options.push(firstInput ? firstInput.value : null);
          }
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      if (!this.getVariantData()) {
        return;
      }
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let activeMedia = productSlider.querySelector(mediaId);
      if (productSlider.flkty && this.hideVariants) {

        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.flkty.selectCell(mediaId);

      } else if (productSlider.flkty) {
        productSlider.flkty.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `properties-fields-${this.dataset.section}--list`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`,`add_to_cart_holder-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          calculateFinalSubtotal();
          document.querySelectorAll(".add_to_cart_wrapp_qty .quantity button").forEach(function(btnqty) {
            btnqty.addEventListener("click", function() {
              calculateFinalSubtotal()
            });
          });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      
      // Skip for Combined Listings products - they handle disabled states server-side
      const isCombinedListing = this.querySelector('input[data-option-value-id]');
      if (isCombinedListing) {
        return;
      }
      
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);
      let items = [];
      const jethotInput = this.form.closest('.product-information--inner').querySelector('.jethot-coating-prod');
      const addonInput = this.form.closest('.product-information--inner').querySelector('.addon-service-prod');
      const head_product_sku = this.form.closest('.product-information--inner').querySelector('.product-sku').getAttribute('data-sku');
      const jethotVal = jethotInput ? jethotInput.value.trim() : '';
      const addonVal = addonInput ? addonInput.value.trim() : '';
      if (jethotVal) {
        items.push({
          id: jethotVal,
          quantity: 1,
          properties: {
            SKU: head_product_sku
          }
        });
      }
      if (addonVal) {
        items.push({
          id: addonVal,
          quantity: 1,
          properties: {
            SKU: head_product_sku
          }
        });
      }
  
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;


      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          if (items.length > 0) {
            const $get_section_content_url = '/?sections='+this.getSectionsToRender().map((section) => section.section);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items })
            })
            .then(res => res.json())
            .then(data => {
              fetch($get_section_content_url, {
                method: "GET"
              }).then((response) => response.json()).then((content_data) => {
                fetch('/cart.js', {
                  method: "GET"
                }).then((response) => response.json()).then((cartContent) => {
                  cartContent["sections"] = content_data;
                  this.renderContents(cartContent);
                  dispatchCustomEvent('cart:item-added', {
                    product: cartContent.hasOwnProperty('items') ? cartContent.items[0] : cartContent
                  });
                }).catch((error) => {
                  console.error("Error:", error);
                });
              }).catch((error) => {
                console.error("Error:", error);
              });
              submitButtons.forEach((submitButton) => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              });
            })
            .catch(err => console.error('Error adding extra products:', err));
          } else{
            this.renderContents(response);
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
          }
        })
        .catch((e) => {
          console.error(e);
        }).finally(() => {
          // submitButtons.forEach((submitButton) => {
          //   submitButton.classList.remove('loading');
          //   submitButton.removeAttribute('aria-disabled');
          // });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      }));



      let product_drawer = document.getElementById('Product-Modal');

      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

function syncPopupHeight() {
  const mainPopup = document.querySelector('.product-modal[open] .product-information--inner');
  const innerPopup = document.querySelector('.jet_hot_coating_popup');

  if (!mainPopup || !innerPopup) return;
  const height = mainPopup.offsetHeight;
  innerPopup.style.height = (height + 80) + 'px';

  // console.log('mainPopup height:', height);
}



function initJetHotAndAddons() {
  // document.addEventListener("DOMContentLoaded", function () {
    /*
      OLD JET-HOT FLOW COMMENTED:
      Previously, clicking a coating card opened .jet_hot_coating_popup and only updated the selected coating after
      the customer clicked "Yes please continue". The client requested direct rounded options where the selected
      option immediately shows its description and added cost below, and "None" hides that detail row.
    */
    const jetHotWrapper = document.querySelector(".jet_hot_coating_wrapp");
    if(jetHotWrapper){
      const coatingProducts = jetHotWrapper.querySelectorAll(".selected-hot-coating-product");
      const selectedSummary = jetHotWrapper.querySelector(".selected-hot-coating");
      const selectedSummaryTitle = jetHotWrapper.querySelector(".selected-hot-coating__title");
      const selectedSummaryPrice = jetHotWrapper.querySelector(".selected-hot-coating__price");
      const productInfo = jetHotWrapper.closest(".product-information--inner");
      const jethotInput = productInfo?.querySelector(".jethot-coating-prod");
      const subtotalElement = document.querySelector(".product-subtotal-price");
      const popup = document.querySelector(".jet_hot_coating_popup");
      const popupWrapper = popup?.querySelector(".jet_hotcoating_popwrapp");
      const closeBtn = popup?.querySelector(".jat-pop-close");
      const declineBtn = popup?.querySelector("#jat-pop-btn-not");
      const approveBtn = popup?.querySelector("#jat-pop-btn-approve");
      let pendingCoatingProduct = null;

      if (popup) popup.classList.remove("active");
      if (selectedSummary) selectedSummary.hidden = true;
      if (jethotInput) jethotInput.value = "";
      if (subtotalElement) subtotalElement.setAttribute("data-jetprice", 0);

      const clearPendingCoating = () => {
        pendingCoatingProduct = null;
        coatingProducts.forEach(el => {
          if (!el.classList.contains("is-confirmed")) {
            el.classList.remove("active");
            el.setAttribute("aria-pressed", "false");
          }
        });
      };

      const clearConfirmedCoating = () => {
        coatingProducts.forEach(el => {
          el.classList.remove("active", "is-confirmed");
          el.setAttribute("aria-pressed", "false");
        });
        if (selectedSummary) selectedSummary.hidden = true;
        if (selectedSummaryTitle) selectedSummaryTitle.textContent = "";
        if (selectedSummaryPrice) selectedSummaryPrice.textContent = "";
        if (jethotInput) jethotInput.value = "";
        if (subtotalElement) subtotalElement.setAttribute("data-jetprice", 0);
      };

      const applyConfirmedCoating = (coatingProduct) => {
        const selectedPrice = coatingProduct.getAttribute("data-price") || "0";
        const selectedTitle = coatingProduct.getAttribute("data-title") || "";
        const selectedProduct = coatingProduct.getAttribute("data-pid") || "";

        coatingProducts.forEach(el => {
          el.classList.remove("active", "is-confirmed");
          el.setAttribute("aria-pressed", "false");
        });

        coatingProduct.classList.add("active", "is-confirmed");
        coatingProduct.setAttribute("aria-pressed", "true");
        if (selectedSummaryTitle) selectedSummaryTitle.textContent = selectedTitle;
        if (selectedSummaryPrice) selectedSummaryPrice.textContent = "+" + $money_format(parseInt(selectedPrice), $shop_money_format);
        if (selectedSummary) selectedSummary.hidden = false;
        if (jethotInput) jethotInput.value = selectedProduct;
        if (subtotalElement) subtotalElement.setAttribute("data-jetprice", selectedPrice);

        // Client requested: price/product should update only after popup confirmation.
        console.log("[Jet-Hot] Confirmed coating:", selectedTitle, "Added price:", selectedPrice);
        calculateFinalSubtotal();
      };

      coatingProducts.forEach(item => {
        item.addEventListener("click", function () {
          const isNone = this.classList.contains("selected-hot-coating-zero");

          if (isNone) {
            if (popup) popup.classList.remove("active");
            pendingCoatingProduct = null;
            clearConfirmedCoating();
            this.classList.add("active", "is-confirmed");
            this.setAttribute("aria-pressed", "true");

            // Client requested: None selected means no Jet-Hot description, no price, and no add-on product in cart.
            console.log("[Jet-Hot] None selected: coating detail hidden and add-on cleared.");
            calculateFinalSubtotal();
            return;
          }

          pendingCoatingProduct = this;
          coatingProducts.forEach(el => {
            if (!el.classList.contains("is-confirmed")) {
              el.classList.remove("active");
              el.setAttribute("aria-pressed", "false");
            }
          });
          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");

          if (popup) popup.classList.add("active");
          console.log("[Jet-Hot] Coating clicked, waiting for popup confirmation:", this.getAttribute("data-title"));
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          if (popup) popup.classList.remove("active");
          clearPendingCoating();
          console.log("[Jet-Hot] Popup closed: pending coating not applied.");
        });
      }

      if (declineBtn) {
        declineBtn.addEventListener("click", function () {
          if (popup) popup.classList.remove("active");
          clearPendingCoating();
          console.log("[Jet-Hot] Popup declined: pending coating not applied.");
        });
      }

      if (approveBtn) {
        approveBtn.addEventListener("click", function () {
          if (popup) popup.classList.remove("active");
          if (pendingCoatingProduct) {
            applyConfirmedCoating(pendingCoatingProduct);
            pendingCoatingProduct = null;
          }
        });
      }

      document.addEventListener("click", function (event) {
        if (popup?.classList.contains("active") && popupWrapper && !popupWrapper.contains(event.target) && !event.target.closest(".selected-hot-coating-product")) {
          popup.classList.remove("active");
          clearPendingCoating();
          console.log("[Jet-Hot] Popup outside click: pending coating not applied.");
        }
      });
    }
    document.querySelectorAll(".add_to_cart_wrapp_qty .quantity button").forEach(function(btnqty) {
      btnqty.addEventListener("click", function() {
        calculateFinalSubtotal()
      });
    });
    var addonCheckbox = document.querySelector(".add_on_service_checkbox");
    var addonCheckboxstiky = document.querySelector(".add_on_service_checkbox_sticky");
    // var jatPopBtnNot = document.getElementById(".jat-pop-btn-not");
    if(addonCheckbox) {
      addonCheckbox.addEventListener("change", function () {
        // if(this.checked){
        //   if(document.getElementById("jat-pop-btn-not")){
        //     document.getElementById("jat-pop-btn-not").click();
        //   }
        // }
        var addonPrice = this.checked ? this.getAttribute("data-price") : 0;
        var addonProdid = this.checked ? this.value : "";
        // var addonProdSku = this.checked ? this.dataset.sku : "";
        // var addonProdProp = this.checked ? this.dataset.sku : "";
        var subtotalElement = document.querySelector(".product-subtotal-price");
        if (addonCheckboxstiky) {
          addonCheckboxstiky.checked = this.checked;
        }
        if(subtotalElement){
          subtotalElement.setAttribute("data-addon", addonPrice);
          if(this.closest('.product-information--inner').querySelector('.addon-service-prod')){
            this.closest('.product-information--inner').querySelector('.addon-service-prod').value = addonProdid;
            // this.closest('.product-information--inner').querySelector('.addon-service-prod').dataset.sku = addonProdSku;
            // this.closest('.product-information--inner').querySelector('.current-product-prop').value = addonProdProp;
          }
          calculateFinalSubtotal();
        }
      });
    }
    if(addonCheckboxstiky){
      addonCheckboxstiky.addEventListener("change", function () {
        // if(this.checked){
        //   if(document.getElementById("jat-pop-btn-not")){
        //     document.getElementById("jat-pop-btn-not").click();
        //   }
        // }
        var addonPrice = this.checked ? this.getAttribute("data-price") : 0;
        var addonProdid = this.checked ? this.value : "";
        // var addonProdProp = this.checked ? this.dataset.sku : "";
        var subtotalElement = document.querySelector(".product-subtotal-price");
        if (addonCheckbox) {
          addonCheckbox.checked = this.checked;
        }
        if(subtotalElement){
          subtotalElement.setAttribute("data-addon", addonPrice);
          if(document.getElementById('addon-service-prod')){
            document.getElementById('addon-service-prod').value = addonProdid;
            // document.getElementById('current-product-prop').value = addonProdProp;
          }
          calculateFinalSubtotal();
        }
      });
    }
  // });
}
function calculateFinalSubtotal() {
  const SubTotal = document.querySelector(".product-subtotal-price");
  if(SubTotal){
    var PriceSub = SubTotal.getAttribute('data-price');
    var QtySub = document.querySelector(".add_to_cart_wrapp_qty .qty").value;
    var SubqtyPrice = parseInt(PriceSub) * parseInt(QtySub);
    var PriceJetoot = SubTotal.getAttribute('data-jetprice') || 0;
    var PriceAddon = SubTotal.getAttribute('data-addon') || 0;
    var FinalSubtotal = parseInt(SubqtyPrice) + parseInt(PriceJetoot) + parseInt(PriceAddon);
    SubTotal.innerText = $money_format(FinalSubtotal, $shop_money_format);
  }
}

// ═══════════════════════════════════════════════════════════════════════════════
// INITIALIZATION
// ═══════════════════════════════════════════════════════════════════════════════

// Run on initial page load
document.addEventListener("DOMContentLoaded", function () {
  initJetHotAndAddons();
});
